import { FunctionComponent } from "react";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { LEAD_SCORE_OPTIONS, REENGAGE_FIELDS } from "../constants/reengage.constants";
import { ReengageSourceFormValues } from "../schema/reengageSource";
import { AdvancedFiltersSection } from "./AdvancedFiltersSection";
import { ReengageDropdownField } from "./ReengageDropdownField";

interface LeadScoringFiltersCardProps {
	control: Control<ReengageSourceFormValues>;
	listId?: number;
}

export const LeadScoringFiltersCard: FunctionComponent<LeadScoringFiltersCardProps> = ({
	control,
	listId,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`list.reengage.${key}`);

	return (
		<div className="bg-background-light border border-border rounded-lg p-4 mb-4">
			<div className="flex items-center gap-2 mb-3.5">
				<span className="text-[13px] font-semibold text-text">{ts("leadScoringTitle")}</span>
				<span className="ml-auto text-xs text-text-meta">{ts("leadScoringSub")}</span>
			</div>

			<ReengageDropdownField
				control={control}
				label={ts("companyCategory")}
				listId={listId}
				name="companyCategory"
				placeholder={ts("allCategories")}
				propertyName={REENGAGE_FIELDS.companyCategory.name}
			/>

			<ReengageDropdownField
				control={control}
				label={ts("personaCategory")}
				listId={listId}
				name="personaCategory"
				placeholder={ts("allPersonas")}
				propertyName={REENGAGE_FIELDS.personaCategory.name}
			/>

			<ReengageDropdownField
				control={control}
				label={ts("leadScoring")}
				name="leadScore"
				placeholder={ts("allScores")}
				staticOptions={LEAD_SCORE_OPTIONS}
			/>

			<AdvancedFiltersSection control={control} listId={listId} />
		</div>
	);
};
